var ScreenSizes;
(function (ScreenSizes) {
    ScreenSizes["Default"] = "Default";
    ScreenSizes["XXL"] = "XXL";
    ScreenSizes["XL"] = "XL";
    ScreenSizes["LG"] = "LG";
    ScreenSizes["MD"] = "MD";
    ScreenSizes["SM"] = "SM";
    ScreenSizes["XS"] = "XS";
    ScreenSizes["XXS"] = "XXS";
})(ScreenSizes || (ScreenSizes = {}));

export { ScreenSizes };
